import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import rootReducer from './reducer'

const store = configureStore({
    reducer: rootReducer,
    // 自动包含 thunk 和 DevTools
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
export default store
